// BOX JS
$("document").ready(function () {
  $(".box").each(function () {
    createBox(this);
  });

  var panelHeight = originalHeight;
  var panelWidth = originalWidth;
  var calcCheck = 0;

  function invalidateCalculation(message) {
    calcCheck = 0;
    $(".panelCountInt, .panelCountFloat").text("");
    $("#quant").val(0);
    $("#cartButton")
      .addClass("disabled")
      .prop("disabled", true);

    if (message) {
      $("#calcError").text(message).show();
    } else {
      $("#calcError").hide();
    }
  }

  /* Visual dimensions for visualisations */
  var maxDimensions = getComputedStyle(document.body)
    .getPropertyValue("--maxDimensions");

  document.documentElement.style.setProperty(
    "--areaHeight",
    maxDimensions + "px"
  );

  document.documentElement.style.setProperty(
    "--areaWidth",
    maxDimensions + "px"
  );

  var inputs = $("#areaHeight,#areaWidth");

  inputs.on("keypress", function (e) {
    if (e.keyCode < 48 || e.keyCode > 57) {
      e.preventDefault();
    }
  });

  $("#areaHeight").on("change", function () {
    var dim = parseInt($(this).val());

    if (dim < panelHeight) {
      $("#roomCover").click();
    }
  });

  invalidateCalculation();

  inputs.on("input", function () {
    invalidateCalculation();
  });

  $("#calculatorForm").on("submit", function (event) {
    event.preventDefault();

    if (calcCheck == 0) {
      $("#calcError").show();
    }
  });

  $("#cartButton").on("click", function (event) {
    event.preventDefault();

    var quantity = Number($("#quant").val());

    if (
      calcCheck == 0 ||
      !Number.isSafeInteger(quantity) ||
      quantity <= 0
    ) {
      invalidateCalculation(
        "Please enter valid dimensions and calculate before adding to cart."
      );
    } else {
      $("input[name='quantity']").val(
        parseInt($("#quant").val())
      );

      $(".add-to-cart").click();
    }
  });

  $("input[name='coverType']").on("change", function () {
    if (this.value == "room") {
      $("#placementControls").hide();
    } else {
      $("#placementControls").show();
    }

    calibrate();
  });

  $("input[name='panelPlacement']").on(
    "change",
    function (event) {
      changeVariable("panelPlacement", event, "");
    }
  );

  var isUpdating = false;

  $(document).on(
    "change",
    "input[name='ogHeight']",
    function (event) {
      if (isUpdating) return;

      isUpdating = true;

      originalHeight = $(this).val();
      panelHeight = originalHeight;

      var matchHeight = $(this).attr("data-value");

      $(
        `.variant-input[data-value^="${matchHeight}"] label`
      ).click();

      calibrate();
      isUpdating = false;
    }
  );

  $("input[name='Height']").on("change", function () {
    if (isUpdating) return;

    isUpdating = true;

    var ht = $(this).val();
    ht = ht.replace(/["']/g, "");

    $("input[name='ogHeight']").attr("checked", false);

    var ele = $(
      `input[name='ogHeight'][data-value='${ht}']`
    );

    $(ele).next("label").click();
    $(ele).attr("checked", true);

    originalHeight = $(ele).val();
    panelHeight = originalHeight;

    calibrate();
    isUpdating = false;
  });

  $(".calc-modal-trigger").on("click", function () {
    console.log("show-calc");

    if ($("#calculator").is(":hidden")) {
      $("body,.page-container,.main-content").css(
        "overflow-y",
        "hidden"
      );
    } else {
      $("body,.page-container,.main-content").css(
        "overflow-y",
        "unset"
      );
    }

    $("#calculator").toggleClass("hidden");
  });

  $(".calc-close").on("click", function () {
    $("body,.page-container,.main-content").css(
      "overflow-y",
      "unset"
    );

    $("#calculator").addClass("hidden");
  });

  $(".function-button").on("click", function () {
    calibrate();
  });

  function changeVariable(varName, e, unit) {
    document.documentElement.style.setProperty(
      "--" + varName,
      e.target.value + unit
    );
  }

  function addPanel() {
    alert();
    $("#wall").append(`<div class="panel"></div>`);
  }

  function calibrate() {
    invalidateCalculation();
    $("#room .back-wall").empty();

    var coverType = $(
      "input[name='coverType']:checked"
    ).val();

    var areaheight = parseInt($("#areaHeight").val());
    var areawidth = parseInt($("#areaWidth").val());

    var selectedHeight = $(
      "input[name='ogHeight']:checked"
    );

    var selectedHeightValue = Number(
      selectedHeight.val()
    );

    if (
      !selectedHeight.length ||
      !Number.isFinite(selectedHeightValue) ||
      selectedHeightValue <= 0
    ) {
      invalidateCalculation(
        "Please select a panel height."
      );
      return;
    }

    panelHeight = selectedHeightValue;

    var rawHeight = Number($("#areaHeight").val());
    var rawWidth = Number($("#areaWidth").val());

    if (
      !Number.isFinite(rawHeight) ||
      !Number.isFinite(rawWidth) ||
      rawHeight <= 0 ||
      rawWidth <= 0 ||
      !areaheight ||
      !areawidth
    ) {
      invalidateCalculation(
        "Please enter valid width and height greater than zero."
      );
      return;
    }

    if (
      !Number.isFinite(Number(panelWidth)) ||
      Number(panelWidth) <= 0 ||
      !Number.isFinite(Number(panelGap)) ||
      Number(panelGap) <= 0
    ) {
      invalidateCalculation(
        "Panel dimensions are unavailable. Please reload the page."
      );
      return;
    }

    var maxDim =
      areaheight >= areawidth ? areaheight : areawidth;

    var height = maxDimensions * (areaheight / maxDim);
    var width = maxDimensions * (areawidth / maxDim);

    document.documentElement.style.setProperty(
      "--areaHeight",
      height + "px"
    );

    document.documentElement.style.setProperty(
      "--areaWidth",
      width + "px"
    );

    panelVWidth = width / (areawidth / panelGap);

    panelVWidth =
      panelVWidth < panelVWidthLimit
        ? panelVWidth
        : panelVWidth;

    /* Set panel height and width */
    var visualHeight =
      coverType == "room" || height < panelHeight
        ? height
        : maxDimensions * (panelHeight / maxDim);

    document.documentElement.style.setProperty(
      "--panelWidth",
      panelVWidth + "px"
    );

    document.documentElement.style.setProperty(
      "--panelHeight",
      visualHeight + "px"
    );

    /* Draw panels */
    var panels = width / panelVWidth;

    for (var i = 1; i <= panels; i++) {
      $("#room .back-wall").append(
        `<div class="panel"></div>`
      );
    }

    calculate();
  }

  function calculate() {
    /* Existing calculation formula preserved */
    var coverType = $(
      "input[name='coverType']:checked"
    ).val();

    var height = parseInt($("#areaHeight").val());
    var width = parseInt($("#areaWidth").val());

    var panelCount = 0;

    if (height == panelHeight) {
      panelCount = width / panelWidth;
    } else if (height > panelHeight) {
      if (coverType == "panel") {
        panelCount = width / panelWidth;
      } else {
        var extraPanels =
          ((height - panelHeight) * width) /
          (panelHeight * panelWidth);

        extraPanels = Math.ceil(extraPanels);

        panelCount += width / panelWidth + extraPanels;
      }
    } else {
      var temp = parseInt(panelHeight / height);
      temp = width / (temp * panelWidth);
      panelCount = temp;
    }

    if (
      !Number.isFinite(panelCount) ||
      panelCount <= 0 ||
      !Number.isSafeInteger(Math.ceil(panelCount))
    ) {
      invalidateCalculation(
        "Unable to calculate. Please check your selections and dimensions."
      );
      return;
    }

    var panelCountInt = Math.ceil(panelCount);
    var panelCountFloat = parseFloat(
      panelCount.toFixed(2)
    );

    $(".panelCountInt").text(panelCountInt + " Boxes");
    $(".panelCountFloat").text(
      panelCountFloat + " Boxes"
    );

    $("#quant").val(parseInt(panelCountInt));

    if (panelCountInt > 0) {
      calcCheck = 1;

      $("#cartButton")
        .removeClass("disabled")
        .prop("disabled", false);
    }
  }
});

function createBox(box) {
  var width = $(box).data("w");
  var height = $(box).data("h");
  var depth = $(box).data("d");

  var posX = $(box).data("x");
  var posY = $(box).data("y");
  var posZ = $(box).data("z");

  var rotX = $(box).data("rx");
  var rotY = $(box).data("ry");
  var rotZ = $(box).data("rz");

  $(box).css({
    width: width,
    height: height,
    transform:
      "rotateX(" +
      rotX +
      "deg) rotateY(" +
      rotY +
      "deg) rotateZ(" +
      rotZ +
      "deg) translate3d(" +
      posX +
      "," +
      posY +
      "," +
      posZ +
      ")"
  });

  var boxContent = `
    <div class="face y-faces top-wall"
      style="height:${depth};width:${width};transform:translateY(calc(-1*${height}/2)) rotateX(90deg);">
    </div>
    <div class="face y-faces bottom-wall"
      style="height:${depth};width:${width};transform:translateY(calc(${height}/2)) rotateX(90deg)">
    </div>
    <div class="face x-faces left-wall"
      style="height:${height};width:${depth};transform:translateX(calc(-1*${width}/2)) rotateY(90deg);">
    </div>
    <div class="face x-faces right-wall"
      style="height:${height};width:${depth};transform:translateX(calc(${width}/2)) rotateY(90deg);">
    </div>
    <div class="face z-faces back-wall"
      style="height:${height};width:${width};transform:translateZ(calc(-1*${depth}/2))">
    </div>
    <div class="face z-faces front-wall"
      style="height:${height};width:${width};transform:translateZ(calc(${depth}/2))">
    </div>
    </div>
  `;

  $(box).append(boxContent);
}

function embedVariants(variants) {
  var variantHtml = "";

  for (var i = 0; i < variants.length; i++) {
    const variant = variants[i];

    if (variant.value.length == 0) {
      continue;
    }

    const label =
      variant.label === "" ? variant.value : variant.label;

    variantHtml += `
      <div class="radio-group"
        style="flex-grow:unset;width:100%;max-width:100px">
        <input
          type="radio"
          data-value="${label.replace(/['"]/g, "")}"
          value="${variant.value}"
          id="ogHeight${i}"
          name="ogHeight"
          class="hidden"
          ${i == 0 ? "checked" : ""}
        >
        <label for="ogHeight${i}"
          class="label-btn label-btn-sm">
          ${label}
        </label>
      </div>
    `;
  }

  document.querySelector("#calculatorVariants").innerHTML =
    variantHtml;
}

// Actual dimensions for calculations in inches